const _excluded = ["className", "style", "children", "modalProps", "modalHeaderProps", "modalBodyProps", "modalFooterProps", "show", "title", "disableModalExit", "footer", "backdrop", "onClose"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { noop } from '@adsk/alloy-react-helpers';
import { stylePropType } from '@adsk/alloy-react-theme';
import Modal from '../Modal';
/**
 * A Simple Modal component.
 */
const SimpleModal = _ref => {
  let {
      className,
      style,
      children,
      modalProps,
      modalHeaderProps,
      modalBodyProps,
      modalFooterProps,
      show = true,
      title,
      disableModalExit,
      footer,
      backdrop,
      onClose = noop
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  disableModalExit = disableModalExit || backdrop === 'static';
  return /*#__PURE__*/React.createElement(Modal, _extends({
    className: className,
    style: style,
    open: show,
    hideOverlay: backdrop === false,
    onClose: onClose
  }, modalProps, props), title && /*#__PURE__*/React.createElement(Modal.Header, modalHeaderProps, title, !disableModalExit && /*#__PURE__*/React.createElement(Modal.Close, {
    onClick: onClose
  })), children && /*#__PURE__*/React.createElement(Modal.Body, modalBodyProps, children), footer && /*#__PURE__*/React.createElement(Modal.Footer, _extends({
    disableBorder: true
  }, modalFooterProps), footer));
};
SimpleModal.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /**
   * Whether to show the modal or not
   */
  show: PropTypes.bool,
  /**
   * Modal content
   */
  children: PropTypes.node,
  /**
   * Optional footer
   */
  footer: PropTypes.node,
  /**
   * Text for the modal title
   */
  title: PropTypes.node,
  /**
   * Determines if the modal cannot be exited (exit button will be hidden and clickoutside will be disabled)
   */
  disableModalExit: PropTypes.bool,
  /**
   * Determines the backdrop of modal.
   */
  backdrop: PropTypes.oneOf(['static', true, false]),
  /**
   * Allows to pass props directly to the Modal component
   */
  modalProps: PropTypes.object,
  /**
   * Allows to pass props directly to the Modal.Header component
   */
  modalHeaderProps: PropTypes.object,
  /**
   * Allows to pass props directly to the Modal.Body component
   */
  modalBodyProps: PropTypes.object,
  /**
   * Allows to pass props directly to the Modal.Footer component
   */
  modalFooterProps: PropTypes.object,
  /**
   * A callback function for when trying to close the modal
   */
  onClose: PropTypes.func
};
export default SimpleModal;
//# sourceMappingURL=SimpleModal.js.map